import React, { MouseEventHandler, useCallback } from "react";

import ComputerChip from "assets/iconsv2/computer-chip-16.svg";
import Plus from "assets/iconsv2/plus-16.svg";
import Cog from "assets/iconsv2/cog-16.svg";
import LogOut from "assets/iconsv2/logout-16.svg";
import MagnifyingGlass from "assets/iconsv2/magnifying-glass-16.svg";
import XMarkCircle from "assets/iconsv2/x-mark-circle-16.svg";

import useRecentSearches from "lib/global_search/useRecentSearches";

import useSession from "lib/useSession";

import SearchItem from "./SearchItem";
import SearchSectionHeader from "./SearchSectionHeader";

const CLEAR_SEARCH_HISTORY_HOVERABLE_ID = "clear-search-history";

type SearchStartStatePropTypes = {
  currentlyFocussedId: string | undefined | null;
  setSearchInput: (searchInput: string) => void;
};
const SearchStartState: React.FC<SearchStartStatePropTypes> = ({ currentlyFocussedId, setSearchInput }) => {
  const [recentSearches, , clearRecentSearches] = useRecentSearches();
  const session = useSession();
  const handleRecentSearchClick: (recentSearch: string) => MouseEventHandler = useCallback(
    (recentSearch) => (event) => {
      event.preventDefault();

      setSearchInput(recentSearch);
    },
    [setSearchInput]
  );

  return (
    <div>
      <div>
        <SearchSectionHeader>Explore</SearchSectionHeader>
        <ul>
          <SearchItem
            href="/store"
            icon={<ComputerChip />}
            hoverableId="browse-extensions"
            currentlyFocussedId={currentlyFocussedId}
          >
            Browse Extensions
          </SearchItem>
          <SearchItem
            href="https://developers.raycast.com"
            icon={<Plus />}
            hoverableId="create-extensions"
            currentlyFocussedId={currentlyFocussedId}
          >
            Create an Extension
          </SearchItem>
        </ul>
      </div>

      {!!(session && session.user) && (
        <div>
          <SearchSectionHeader>Account</SearchSectionHeader>
          <ul>
            <SearchItem
              href={`/${session.user.handle}`}
              icon={<Cog />}
              hoverableId="view-account"
              currentlyFocussedId={currentlyFocussedId}
            >
              View Account
            </SearchItem>

            <SearchItem
              href="/users/sign_out"
              textStyle="danger"
              icon={<LogOut />}
              hoverableId="log-out"
              currentlyFocussedId={currentlyFocussedId}
            >
              Log Out
            </SearchItem>
          </ul>
        </div>
      )}

      {!!recentSearches.length && (
        <div>
          <SearchSectionHeader>Recently Searched</SearchSectionHeader>
          <ul>
            {recentSearches.map((recentSearch) => (
              <SearchItem
                key={recentSearch}
                icon={<MagnifyingGlass />}
                hoverableId={`recent-${recentSearch}`}
                currentlyFocussedId={currentlyFocussedId}
                onClick={handleRecentSearchClick(recentSearch)}
              >
                {recentSearch}
              </SearchItem>
            ))}
            <SearchItem
              textStyle="danger"
              icon={<XMarkCircle />}
              hoverableId={CLEAR_SEARCH_HISTORY_HOVERABLE_ID}
              currentlyFocussedId={currentlyFocussedId}
              onClick={clearRecentSearches}
            >
              Clear Recent Searches
            </SearchItem>
          </ul>
        </div>
      )}
    </div>
  );
};

export default SearchStartState;
export { CLEAR_SEARCH_HISTORY_HOVERABLE_ID };
